import React from 'react';
import { BsArrowLeftCircleFill, BsFillXCircleFill } from 'react-icons/bs';

interface ModalProps {
  title: string;
  width?: string;
  showBack?: boolean;
  onClose: Function;
  onBack?: Function;
  children: any;
}

class Modal extends React.Component<ModalProps, {}> {
  constructor(props:ModalProps) {
    super(props);
  }

  render() {
    let width = this.props.width ? this.props.width : '300px';
    return (
      <div className="modal open">
        <div className="modal-content" style={{width}}>
          <div className="site-page-column">
            <div className="site-page-row" style={{justifyContent: 'space-between'}}>
              <div className="site-page-row">
                {this.props.showBack &&
                  <div style={{display: 'flex', alignItems: 'center', cursor: 'pointer', color: 'var(--panel-subtext-color)'}} onClick={()=>this.props.onBack()}>
                    <BsArrowLeftCircleFill size={22} />
                  </div>
                }
                <div style={{fontSize: '1.1em', textAlign: 'left'}}>{this.props.title}</div>
              </div>
              <div style={{display: 'flex', alignItems: 'center', cursor: 'pointer', color: 'var(--panel-subtext-color)'}} onClick={()=>this.props.onClose()}>
                <BsFillXCircleFill size={22} />
              </div>
            </div>
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
}

export default Modal;